export const SUM_TEXT = {
  FREE: 'free',
  ONE_TIME: 'one-time',
  FEE: 'fee',
  MO: '/mo',
  MONTH: '/month',
  HOSTING: 'hosting',
};
